import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

// @ts-ignore
import customerVideos from '../assets/customerVideos.png';
// @ts-ignore
import documentation from '../assets/documentation.png';
// @ts-ignore
import marketingContent from '../assets/marketingContent.png';
// @ts-ignore
import publicForum from '../assets/publicForum.png';
// @ts-ignore
import technicalSupport from '../assets/technicalSupport.png';
import { messages as contentLibraryMessages } from '../i18n/content-library-messages';

import { tagBackgroundColors, tagBorderColors, templateStyles } from './styles';

const ContentLibrary: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={348}
      height={142}
      fill="none"
    >
      <g clipPath="url(#contentLibrary-a)">
        <rect width={336} height={142} fill={templateStyles['background']} rx={3} />
        <g filter="url(#contentLibrary-b)">
          <g clipPath="url(#contentLibrary-c)">
            <rect
              width={80.94}
              height={110.31}
              x={2.45}
              y={1.22}
              fill={templateStyles['background']}
              rx={1.84}
            />
            <path fill="url(#contentLibrary-d)" d="M4.9 3.67h76.04v50.8H4.9z" />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.9}
              fontWeight={600}
              letterSpacing={0}
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={6.12} y={63.11}>
                {formatMessage(contentLibraryMessages['content-library.entry-1-cell-1'])}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={6.12} y={73.13}>
                {formatMessage(
                  contentLibraryMessages['content-library.entry-1-cell-2']
                ).substring(0, 37)}
              </tspan>
              <tspan x={6.12} y={79.25}>
                {formatMessage(
                  contentLibraryMessages['content-library.entry-1-cell-2']
                ).substring(37)}
              </tspan>
            </text>
            <rect
              width={35.7}
              height={5.92}
              x={6}
              y={84.2}
              fill={tagBackgroundColors['blueLight']}
              rx={0.78}
            />
            <rect
              width={35.7}
              height={5.92}
              x={6}
              y={84.2}
              stroke={tagBorderColors['blueLight']}
              strokeWidth={0.3}
              rx={0.78}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={7.45} y={88.75}>
                {formatMessage(
                  contentLibraryMessages['content-library.field-3-select-option-3']
                )}
              </tspan>
            </text>
            <rect
              width={19.7}
              height={5.92}
              x={6}
              y={93}
              fill={tagBackgroundColors['purpleLight']}
              rx={0.78}
            />
            <rect
              width={19.7}
              height={5.92}
              x={6}
              y={93}
              stroke={tagBorderColors['purpleLight']}
              strokeWidth={0.3}
              rx={0.78}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={7.37} y={97.32}>
                {formatMessage(
                  contentLibraryMessages['content-library.field-4-select-option-1']
                )}
              </tspan>
            </text>
            <g clipPath="url(#contentLibrary-g)">
              <rect
                width={73.6}
                height={6.12}
                x={6.12}
                y={101.74}
                fill={templateStyles['background']}
                rx={0.92}
              />
              <g clipPath="url(#contentLibrary-h)">
                <path
                  fill={templateStyles['background']}
                  d="M7.04 102.66h4.28v4.28H7.04z"
                />
                <path
                  fill={templateStyles['link']}
                  d="M8.6 104.71c-.05-.05-.12-.04-.15.02l-.69 1.38v.08a.08.08 0 0 0 .08.04h.96l.05-.01.03-.03c.2-.44.08-1.09-.29-1.48Zm.5-1.26c-.39.61-.36 1.3-.1 1.8l.46.94c.01.03.04.04.07.04h1.01a.08.08 0 0 0 .04-.08v-.04l-1.34-2.66c-.03-.06-.1-.06-.14 0Z"
                />
              </g>
              <path
                fill={templateStyles['link']}
                d="m13.25 106.74-.82-3.02h.4l.6 2.46h.02l.67-2.46h.38l.68 2.46h.02l.6-2.46h.4l-.82 3.02h-.36l-.7-2.38h-.02l-.7 2.38h-.35Zm3.5 0v-3.15h.36v1.24h.03a.64.64 0 0 1 .25-.28c.1-.07.24-.1.41-.1.17 0 .31.03.43.1.12.06.2.16.27.28.06.12.09.28.09.45v1.46h-.36v-1.37c0-.2-.05-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.53.53 0 0 0-.2.22c-.06.1-.08.2-.08.34v1.33h-.36Zm2.6.8-.07-.01h-.08v-.3H19.35c.1 0 .18-.02.25-.08a.55.55 0 0 0 .16-.27l.04-.13-.83-2.26h.39l.7 2.08-.15-.23h.17l-.15.23.7-2.08H21l-.88 2.4c-.06.16-.13.3-.2.39a.56.56 0 0 1-.24.2c-.09.03-.2.05-.33.05Zm3.54 0-.08-.01h-.08v-.3H22.88c.1 0 .19-.02.25-.08a.55.55 0 0 0 .16-.27l.04-.13-.83-2.26h.39l.7 2.08-.15-.23h.17l-.14.23.69-2.08h.38l-.88 2.4c-.06.16-.13.3-.2.39a.56.56 0 0 1-.24.2c-.09.03-.2.05-.33.05Zm2.97-.76c-.2 0-.4-.04-.55-.14a.95.95 0 0 1-.36-.4 1.42 1.42 0 0 1-.12-.62c0-.25.04-.46.12-.63.09-.17.2-.3.36-.4.16-.1.34-.14.55-.14.22 0 .4.05.56.14.15.1.27.23.36.4.08.17.12.38.12.62 0 .25-.04.45-.12.63a.94.94 0 0 1-.92.54Zm0-.32c.15 0 .27-.03.37-.1.1-.07.17-.16.22-.29.06-.12.08-.27.08-.45 0-.19-.02-.34-.08-.46a.6.6 0 0 0-.22-.29.63.63 0 0 0-.37-.1.63.63 0 0 0-.36.1.62.62 0 0 0-.23.29 1.2 1.2 0 0 0-.07.45c0 .19.02.34.07.46.06.13.13.22.23.29.1.07.22.1.36.1Zm2.36.32a.88.88 0 0 1-.42-.1.63.63 0 0 1-.27-.28 1.09 1.09 0 0 1-.08-.45v-1.46h.36v1.37c0 .2.04.35.12.45.08.1.2.15.39.15.1 0 .18-.01.26-.04a.5.5 0 0 0 .3-.33.85.85 0 0 0 .05-.27v-1.33h.36v2.25h-.36v-.33h-.04a.62.62 0 0 1-.37.33.92.92 0 0 1-.3.04Zm1.75-.04v-2.25h.37v.33h.03a.53.53 0 0 1 .22-.27.7.7 0 0 1 .38-.1.7.7 0 0 1 .1 0l.08.01v.36a1.1 1.1 0 0 0-.22-.02.66.66 0 0 0-.3.06.53.53 0 0 0-.22.2.54.54 0 0 0-.07.29v1.4h-.37Zm3.64.02c-.23 0-.4-.05-.5-.14-.1-.1-.16-.25-.16-.46v-1.37h-.36v-.3h.36v-.59h.38v.59h.49v.3h-.5v1.27c0 .14.03.23.08.3.05.05.14.08.25.08h.08l.09-.01v.3c-.03.02-.07.02-.1.02l-.11.01Zm1.65.02c-.22 0-.4-.05-.56-.14a.94.94 0 0 1-.35-.4 1.43 1.43 0 0 1-.13-.62c0-.23.04-.44.13-.61.08-.18.2-.31.35-.41.15-.1.33-.15.53-.15s.38.05.53.14c.15.1.26.23.34.4.08.17.12.36.12.59v.14H34.4v-.3h1.62l-.18.27v-.14c0-.18-.03-.32-.08-.44a.56.56 0 0 0-.54-.34.6.6 0 0 0-.33.1.6.6 0 0 0-.22.25.98.98 0 0 0-.09.43v.14c0 .17.03.3.09.42.05.11.13.2.23.26s.22.09.35.09c.1 0 .2-.02.27-.04a.59.59 0 0 0 .19-.11.39.39 0 0 0 .1-.13v-.02h.37v.02a.68.68 0 0 1-.1.22.85.85 0 0 1-.48.33c-.1.04-.22.05-.35.05Zm2.14 0a.88.88 0 0 1-.38-.08.66.66 0 0 1-.27-.23.63.63 0 0 1-.1-.36.6.6 0 0 1 .1-.34c.06-.1.15-.17.27-.23.13-.05.28-.09.45-.1l.83-.05v.3l-.79.05a.68.68 0 0 0-.37.1.3.3 0 0 0-.12.26c0 .12.04.2.13.27s.2.1.33.1c.12 0 .23-.03.33-.08s.17-.11.22-.2a.51.51 0 0 0 .09-.29v-.7c0-.14-.05-.25-.13-.32s-.21-.1-.38-.1a.67.67 0 0 0-.33.06.35.35 0 0 0-.18.2v.01h-.36v-.01a.6.6 0 0 1 .15-.3.78.78 0 0 1 .3-.22c.13-.05.27-.07.43-.07.19 0 .34.03.47.09.13.06.22.14.29.26.07.1.1.24.1.4v1.54h-.36v-.33h-.04a.76.76 0 0 1-.68.37Zm1.75-.04v-2.25h.36v.34h.03a.6.6 0 0 1 .23-.28c.1-.07.23-.1.38-.1.1 0 .2.02.28.05.08.03.15.08.2.14.06.06.11.13.15.2h.03a.73.73 0 0 1 .4-.34c.09-.03.19-.05.29-.05.15 0 .28.03.39.08.1.06.19.14.24.25.06.11.09.25.09.4v1.56h-.37v-1.47c0-.11-.01-.2-.05-.28a.33.33 0 0 0-.15-.16.55.55 0 0 0-.27-.06.5.5 0 0 0-.46.26.53.53 0 0 0-.06.26v1.45h-.36v-1.53a.44.44 0 0 0-.06-.23.38.38 0 0 0-.16-.16.53.53 0 0 0-.25-.05c-.1 0-.19.03-.27.08a.55.55 0 0 0-.18.2.62.62 0 0 0-.07.3v1.4h-.36Zm5.7.04c-.16 0-.31-.02-.44-.07a.78.78 0 0 1-.31-.22.6.6 0 0 1-.14-.32h.38c.03.1.09.17.18.22.09.06.2.09.35.09.1 0 .19-.02.26-.04a.46.46 0 0 0 .19-.13.27.27 0 0 0 .06-.18.25.25 0 0 0-.09-.2.7.7 0 0 0-.3-.13l-.35-.08a1.26 1.26 0 0 1-.35-.13.53.53 0 0 1-.2-.2.58.58 0 0 1-.06-.28c0-.13.03-.24.1-.34.08-.1.18-.18.3-.24.14-.05.28-.08.44-.08.15 0 .3.02.42.07a.7.7 0 0 1 .3.21c.07.1.11.2.13.32h-.36a.37.37 0 0 0-.16-.22.6.6 0 0 0-.33-.08.6.6 0 0 0-.24.05.4.4 0 0 0-.17.11.27.27 0 0 0-.06.18c0 .05.01.1.04.14.03.04.07.07.12.1a1 1 0 0 0 .22.08l.35.08c.2.05.37.13.47.22.1.1.16.23.16.39 0 .14-.04.26-.12.36a.79.79 0 0 1-.33.24c-.13.05-.29.08-.46.08Zm1.5-.04v-3.15h.36v1.24h.03a.64.64 0 0 1 .25-.28c.1-.07.24-.1.4-.1.18 0 .32.03.44.1.11.06.2.16.26.28.06.12.1.28.1.45v1.46h-.37v-1.37c0-.2-.04-.35-.13-.45-.08-.1-.22-.15-.4-.15a.6.6 0 0 0-.3.08.53.53 0 0 0-.21.22c-.05.1-.07.2-.07.34v1.33h-.37Zm3.42.04c-.21 0-.4-.04-.55-.14a.95.95 0 0 1-.36-.4 1.42 1.42 0 0 1-.13-.62c0-.25.04-.46.13-.63.08-.17.2-.3.36-.4.15-.1.34-.14.55-.14.22 0 .4.05.55.14.16.1.28.23.36.4.09.17.13.38.13.62 0 .25-.04.45-.13.63a.94.94 0 0 1-.9.54Zm0-.32c.14 0 .26-.03.36-.1.1-.07.18-.16.23-.29.05-.12.08-.27.08-.45 0-.19-.03-.34-.08-.46a.6.6 0 0 0-.23-.29.63.63 0 0 0-.36-.1.63.63 0 0 0-.36.1.62.62 0 0 0-.23.29 1.2 1.2 0 0 0-.08.45c0 .19.03.34.08.46.05.13.13.22.23.29.1.07.22.1.36.1Zm2.36.32a.88.88 0 0 1-.43-.1.63.63 0 0 1-.26-.28 1.09 1.09 0 0 1-.09-.45v-1.46h.37v1.37c0 .2.04.35.12.45.07.1.2.15.38.15.1 0 .2-.01.27-.04a.5.5 0 0 0 .3-.33.85.85 0 0 0 .04-.27v-1.33h.37v2.25h-.37v-.33h-.03a.62.62 0 0 1-.37.33.92.92 0 0 1-.3.04Zm1.77-.04v-3.15h.36v3.15h-.36Zm1.9.04a.87.87 0 0 1-.84-.55 1.5 1.5 0 0 1-.11-.61c0-.24.04-.45.11-.62a.87.87 0 0 1 .83-.55c.1 0 .2.02.3.05.09.03.17.08.24.14.07.05.13.12.17.2h.03v-1.25h.36v3.15h-.36v-.36h-.03a.77.77 0 0 1-.18.22.78.78 0 0 1-.53.18Zm.08-.32a.6.6 0 0 0 .58-.4c.05-.12.08-.27.08-.44 0-.18-.03-.33-.08-.46a.65.65 0 0 0-.23-.29.6.6 0 0 0-.35-.1.6.6 0 0 0-.36.1.64.64 0 0 0-.22.3c-.05.12-.08.27-.08.44 0 .18.03.33.08.46s.13.22.22.29c.1.07.22.1.36.1Zm2.93.28v-2.25h.36v2.25h-.36Zm.18-2.69a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18.25.25 0 0 1 .25-.25c.07 0 .13.02.18.07.05.05.07.11.07.18 0 .07-.02.13-.07.18a.24.24 0 0 1-.18.07Zm.87 2.7v-2.26h.36v.34h.03a.64.64 0 0 1 .25-.28c.1-.07.24-.1.41-.1.25 0 .45.07.58.22.14.14.2.34.2.61v1.46h-.36v-1.37c0-.2-.04-.35-.13-.45-.08-.1-.21-.15-.4-.15a.6.6 0 0 0-.3.08.53.53 0 0 0-.2.22c-.06.1-.08.2-.08.34v1.33h-.36Zm3.05 0-.83-2.26h.38l.62 1.86h.03l.62-1.86h.38l-.83 2.25h-.37Zm2.52.03c-.21 0-.4-.05-.55-.14a.94.94 0 0 1-.36-.4 1.43 1.43 0 0 1-.12-.62c0-.23.04-.44.12-.61a.96.96 0 0 1 .89-.56c.2 0 .38.05.53.14.14.1.26.23.34.4.08.17.11.36.11.59v.14h-1.8v-.3h1.62l-.18.27v-.14c0-.18-.03-.32-.08-.44a.56.56 0 0 0-.54-.34.6.6 0 0 0-.33.1.6.6 0 0 0-.22.25.98.98 0 0 0-.09.43v.14c0 .17.03.3.08.42.06.11.13.2.24.26.1.06.21.09.35.09.1 0 .2-.02.27-.04a.59.59 0 0 0 .18-.11.38.38 0 0 0 .1-.13l.01-.02h.37v.02a.69.69 0 0 1-.11.22.85.85 0 0 1-.47.33c-.1.04-.23.05-.36.05Zm2.3 0c-.16 0-.31-.02-.44-.07a.78.78 0 0 1-.3-.22.6.6 0 0 1-.15-.32h.38c.03.1.09.17.18.22.09.06.2.09.35.09.1 0 .19-.02.26-.04a.46.46 0 0 0 .19-.13.27.27 0 0 0 .06-.18.25.25 0 0 0-.09-.2.7.7 0 0 0-.3-.13l-.35-.08a1.26 1.26 0 0 1-.34-.13.53.53 0 0 1-.2-.2.58.58 0 0 1-.07-.28c0-.13.04-.24.1-.34.08-.1.18-.18.3-.24.14-.05.28-.08.44-.08.16 0 .3.02.42.07a.7.7 0 0 1 .3.21c.07.1.11.2.13.32h-.36a.37.37 0 0 0-.16-.22.6.6 0 0 0-.33-.08.6.6 0 0 0-.24.05.4.4 0 0 0-.17.11.27.27 0 0 0-.06.18c0 .05.02.1.04.14.03.04.07.07.12.1a1 1 0 0 0 .22.08l.35.08c.21.05.37.13.47.22.1.1.16.23.16.39 0 .14-.04.26-.12.36a.79.79 0 0 1-.33.24c-.13.05-.28.08-.46.08Zm2.25-.02c-.23 0-.4-.05-.5-.14-.1-.1-.16-.25-.16-.46v-1.37h-.35v-.3h.35v-.59h.38v.59h.5v.3h-.5v1.27c0 .14.02.23.08.3.05.05.13.08.25.08h.08l.08-.01v.3c-.03.02-.07.02-.1.02l-.1.01Zm2.76 0c-.23 0-.4-.05-.5-.14-.1-.1-.16-.25-.16-.46v-1.37h-.35v-.3h.35v-.59h.38v.59h.5v.3h-.5v1.27c0 .14.03.23.08.3.05.05.13.08.25.08h.08l.08-.01v.3c-.03.02-.06.02-.1.02l-.1.01Zm.77-.02v-2.25h.36v2.25h-.36Zm.18-2.69a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18.25.25 0 0 1 .25-.25c.07 0 .13.02.18.07.05.05.07.11.07.18 0 .07-.02.13-.07.18a.24.24 0 0 1-.18.07Zm1.16 2.71a.27.27 0 0 1-.27-.27c0-.07.03-.14.08-.19a.27.27 0 0 1 .2-.08c.07 0 .13.03.19.08.05.05.08.12.08.2a.27.27 0 0 1-.28.26Zm1.1 0a.27.27 0 0 1-.27-.27c-.01-.07.02-.14.07-.19a.27.27 0 0 1 .2-.08c.07 0 .13.03.18.08.06.05.08.12.08.2a.27.27 0 0 1-.27.26Zm1.08 0a.27.27 0 0 1-.27-.27c0-.07.02-.14.08-.19a.27.27 0 0 1 .19-.08c.08 0 .14.03.2.08.05.05.07.12.07.2a.27.27 0 0 1-.27.26Z"
              />
            </g>
            <rect
              width={73.6}
              height={6.12}
              x={6.12}
              y={101.74}
              stroke={templateStyles['border']}
              strokeWidth={0.31}
              rx={0.92}
            />
          </g>
        </g>
        <g filter="url(#contentLibrary-i)">
          <g clipPath="url(#contentLibrary-j)">
            <rect
              width={80.94}
              height={110.31}
              x={85.84}
              y={1.22}
              fill={templateStyles['background']}
              rx={1.84}
            />
            <path fill="url(#contentLibrary-k)" d="M88.28 3.67h76.04v50.8H88.28z" />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.9}
              fontWeight={600}
              letterSpacing={0}
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={89.51} y={63.11}>
                {formatMessage(contentLibraryMessages['content-library.entry-2-cell-1'])}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={89.51} y={73.13}>
                {formatMessage(
                  contentLibraryMessages['content-library.entry-2-cell-4']
                ).substring(0, 26)}
              </tspan>
              <tspan x={88.51} y={79.25}>
                {formatMessage(
                  contentLibraryMessages['content-library.entry-2-cell-4']
                ).substring(26)}
              </tspan>
            </text>
            <rect
              width={15.7}
              height={5.92}
              x={89.51}
              y={84.2}
              fill={tagBackgroundColors['greenLight']}
              rx={0.78}
            />
            <rect
              width={15.7}
              height={5.92}
              x={89.51}
              y={84.2}
              stroke={tagBorderColors['greenLight']}
              strokeWidth={0.3}
              rx={0.78}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={90.95} y={88.75}>
                {formatMessage(
                  contentLibraryMessages['content-library.field-3-select-option-1']
                )}
              </tspan>
            </text>
            <rect
              width={24.7}
              height={5.92}
              x={89.51}
              y={93}
              fill={tagBackgroundColors['redLight']}
              rx={0.78}
            />
            <rect
              width={24.7}
              height={5.92}
              x={89.51}
              y={93}
              stroke={tagBorderColors['redLight']}
              strokeWidth={0.3}
              rx={0.78}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={91.16} y={97.32}>
                {formatMessage(
                  contentLibraryMessages['content-library.field-4-select-option-3']
                )}
              </tspan>
            </text>
            <g clipPath="url(#contentLibrary-n)">
              <rect
                width={73.6}
                height={6.12}
                x={89.51}
                y={101.74}
                fill={templateStyles['background']}
                rx={0.92}
              />
              <g clipPath="url(#contentLibrary-o)">
                <path
                  fill={templateStyles['background']}
                  d="M90.43 102.66h4.28v4.28h-4.28z"
                />
                <path
                  fill={templateStyles['link']}
                  d="M91.98 104.71c-.04-.05-.1-.04-.14.02l-.7 1.38v.04l.01.04a.08.08 0 0 0 .07.04h.97l.04-.01c.02 0 .03-.02.03-.03.21-.44.09-1.09-.28-1.48Zm.5-1.26c-.38.61-.35 1.3-.1 1.8l.47.94c.01.03.04.04.07.04h1.01a.08.08 0 0 0 .04-.08v-.04l-1.34-2.66c-.03-.06-.1-.06-.14 0Z"
                />
              </g>
              <path
                fill={templateStyles['link']}
                d="m96.35 105.73-.02-.54h.1l1.32-1.47h.47l-1.25 1.35-.18.17-.44.5Zm-.34 1.01v-3.02h.38v3.02h-.38Zm1.83 0-1.13-1.5.26-.26 1.36 1.76h-.49Zm.96 0v-2.25h.36v2.25h-.36Zm.18-2.69a.25.25 0 0 1-.17-.07.25.25 0 0 1-.08-.18c0-.07.03-.13.08-.18.05-.05.1-.07.17-.07s.13.03.18.07c.05.05.07.11.07.18 0 .07-.02.13-.07.18a.24.24 0 0 1-.18.07Zm1.8 2.73c-.22 0-.4-.05-.56-.14a.97.97 0 0 1-.36-.4 1.41 1.41 0 0 1-.12-.63c0-.24.04-.44.12-.62.09-.17.2-.3.36-.4.16-.1.34-.14.55-.14.18 0 .34.03.47.1a.84.84 0 0 1 .47.62h-.36a.52.52 0 0 0-.19-.28.61.61 0 0 0-.39-.12.6.6 0 0 0-.58.4c-.05.12-.08.27-.08.44 0 .17.03.32.08.45.06.13.13.23.23.3.1.07.22.1.35.1.15 0 .28-.03.37-.1.1-.06.17-.16.21-.28v-.02h.36v.02a.95.95 0 0 1-.16.37.8.8 0 0 1-.31.24 1.1 1.1 0 0 1-.47.1Zm1.49-.04v-3.15h.36v3.15h-.36Zm1.42 0-.88-1.1.27-.23 1.07 1.33h-.46Zm-1.1-.8-.02-.47h.1l.97-.98h.44l-1.07 1.03-.09.09-.33.32Zm4.11.84c-.2 0-.4-.04-.55-.14a.95.95 0 0 1-.36-.4 1.42 1.42 0 0 1-.13-.62c0-.25.05-.46.13-.63.09-.17.2-.3.36-.4.16-.1.34-.14.55-.14.22 0 .4.05.56.14.15.1.27.23.36.4.08.17.13.38.13.62 0 .25-.05.45-.13.63a.94.94 0 0 1-.92.54Zm0-.32c.15 0 .27-.03.37-.1.1-.07.17-.16.22-.29.06-.12.08-.27.08-.45 0-.19-.02-.34-.08-.46a.6.6 0 0 0-.22-.29.63.63 0 0 0-.36-.1.63.63 0 0 0-.37.1.62.62 0 0 0-.23.29c-.05.12-.07.28-.07.45 0 .19.02.34.07.46.06.13.13.22.23.29.1.07.22.1.36.1Zm1.76.28v-1.95h-.37v-.3h.37v-.25c0-.15.02-.28.07-.38.05-.1.13-.17.22-.22a.8.8 0 0 1 .36-.07 1.23 1.23 0 0 1 .25.02v.3l-.08-.02h-.1c-.12 0-.22.03-.27.1-.06.06-.09.15-.09.28v.24h.52v.3h-.52v1.95h-.36Zm1.55 0v-1.95h-.37v-.3h.37v-.25c0-.15.03-.28.07-.38.06-.1.13-.17.23-.22a.8.8 0 0 1 .36-.07 1.22 1.22 0 0 1 .24.02v.3l-.08-.02h-.09c-.13 0-.22.03-.28.1-.06.06-.08.15-.08.28v.24h.5v.3h-.5v1.95H110Zm3.41.02c-.23 0-.4-.05-.5-.14-.1-.1-.16-.25-.16-.46v-1.37h-.36v-.3h.36v-.59h.38v.59h.5v.3h-.5v1.27c0 .14.02.23.07.3.05.05.14.08.25.08h.09l.08-.01v.3c-.03.02-.07.02-.1.02l-.11.01Zm.78-.02v-3.15h.36v1.24h.03a.64.64 0 0 1 .25-.28c.1-.07.24-.1.41-.1.17 0 .31.03.43.1.12.06.2.16.27.28.06.12.09.28.09.45v1.46h-.37v-1.37c0-.2-.04-.35-.13-.45-.08-.1-.21-.15-.4-.15a.6.6 0 0 0-.3.08.53.53 0 0 0-.2.22c-.06.1-.08.2-.08.34v1.33h-.36Zm3.42.04c-.22 0-.4-.05-.56-.14a.94.94 0 0 1-.35-.4 1.43 1.43 0 0 1-.13-.62c0-.23.05-.44.13-.61.08-.18.2-.31.35-.41.15-.1.33-.15.53-.15.21 0 .39.05.53.14.15.1.26.23.34.4.08.17.12.36.12.59v.14h-1.8v-.3h1.61l-.18.27v-.14c0-.18-.02-.32-.07-.44a.56.56 0 0 0-.55-.34.6.6 0 0 0-.32.1.6.6 0 0 0-.23.25.98.98 0 0 0-.08.43v.14c0 .17.02.3.08.42.05.11.13.2.23.26s.22.09.36.09c.1 0 .19-.02.26-.04a.57.57 0 0 0 .19-.11.39.39 0 0 0 .1-.13v-.02h.37v.02a.66.66 0 0 1-.1.22.83.83 0 0 1-.2.2.99.99 0 0 1-.27.13c-.11.04-.23.05-.36.05Zm2.73-.04v-2.25h.36v.34h.04a.64.64 0 0 1 .24-.28c.11-.07.25-.1.41-.1.26 0 .45.07.59.22.14.14.2.34.2.61v1.46h-.36v-1.37c0-.2-.04-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.53.53 0 0 0-.2.22c-.05.1-.08.2-.08.34v1.33h-.36Zm3.42.04c-.21 0-.4-.05-.55-.14a.95.95 0 0 1-.36-.4 1.43 1.43 0 0 1-.12-.62c0-.23.04-.44.12-.61a.96.96 0 0 1 .89-.56c.2 0 .38.05.53.14.14.1.26.23.33.4.08.17.13.36.13.59v.14h-1.81v-.3h1.62l-.18.27v-.14c0-.18-.03-.32-.08-.44a.56.56 0 0 0-.54-.34.6.6 0 0 0-.33.1.6.6 0 0 0-.23.25.98.98 0 0 0-.08.43v.14c0 .17.03.3.08.42.06.11.14.2.23.26.1.06.22.09.36.09.1 0 .2-.02.27-.04a.59.59 0 0 0 .18-.11.39.39 0 0 0 .1-.13l.01-.02h.37v.02a.68.68 0 0 1-.11.22.86.86 0 0 1-.47.33c-.1.04-.22.05-.36.05Zm1.97-.04-.64-2.25h.37l.44 1.8h.03l.5-1.8h.35l.5 1.8h.04l.44-1.8h.37l-.64 2.25h-.36l-.5-1.74h-.04l-.5 1.74h-.36Zm4.27.8-.07-.01h-.09v-.3a.7.7 0 0 0 .08 0h.07c.1 0 .2-.02.26-.08a.54.54 0 0 0 .16-.27l.04-.13-.83-2.26h.38l.7 2.08-.15-.23h.18l-.15.23.7-2.08h.38l-.88 2.4c-.06.16-.13.3-.2.39a.56.56 0 0 1-.24.2.85.85 0 0 1-.34.05Zm2.98-.76c-.22 0-.4-.05-.56-.14a.94.94 0 0 1-.36-.4 1.43 1.43 0 0 1-.12-.62c0-.23.04-.44.13-.61.08-.18.2-.31.35-.41.15-.1.33-.15.53-.15s.38.05.53.14c.15.1.26.23.34.4.08.17.12.36.12.59v.14h-1.81v-.3h1.62l-.18.27v-.14c0-.18-.03-.32-.08-.44a.56.56 0 0 0-.54-.34.6.6 0 0 0-.55.35.98.98 0 0 0-.09.43v.14c0 .17.03.3.09.42a.6.6 0 0 0 .58.35c.1 0 .2-.02.27-.04a.6.6 0 0 0 .19-.11.39.39 0 0 0 .1-.13v-.02h.37v.02a.68.68 0 0 1-.1.22.83.83 0 0 1-.2.2.99.99 0 0 1-.28.13c-.1.04-.22.05-.35.05Zm2.14 0a.88.88 0 0 1-.38-.08.63.63 0 0 1-.37-.59.6.6 0 0 1 .1-.34c.06-.1.15-.17.28-.23.12-.05.27-.09.44-.1l.83-.05v.3l-.79.05a.68.68 0 0 0-.37.1.3.3 0 0 0-.12.26c0 .12.04.2.13.27s.2.1.33.1c.12 0 .23-.03.33-.08s.17-.11.22-.2a.51.51 0 0 0 .09-.29v-.7c0-.14-.05-.25-.13-.32-.09-.07-.21-.1-.38-.1a.67.67 0 0 0-.33.06.35.35 0 0 0-.18.2v.01h-.36v-.01a.61.61 0 0 1 .15-.3.78.78 0 0 1 .3-.22c.13-.05.27-.07.43-.07.19 0 .34.03.47.09.13.06.22.14.29.26.07.1.1.24.1.4v1.54h-.36v-.33h-.04a.75.75 0 0 1-.68.37Zm1.75-.04v-2.25h.36v.33h.03a.54.54 0 0 1 .22-.27.7.7 0 0 1 .39-.1h.1l.08.01v.36a1.13 1.13 0 0 0-.23-.02.66.66 0 0 0-.3.06.53.53 0 0 0-.22.2.55.55 0 0 0-.07.29v1.4h-.36Zm3.27 0-.63-2.25h.36l.44 1.8h.04l.5-1.8h.35l.5 1.8h.03l.45-1.8h.36l-.63 2.25h-.37l-.5-1.74H141l-.5 1.74h-.36Zm2.89 0v-2.25h.36v2.25h-.36Zm.18-2.69a.24.24 0 0 1-.18-.07.25.25 0 0 1-.07-.18c0-.07.03-.13.07-.18.06-.05.11-.07.18-.07.07 0 .13.03.18.07.05.05.07.11.07.18 0 .07-.02.13-.07.18a.24.24 0 0 1-.18.07Zm1.67 2.71c-.23 0-.4-.05-.5-.14-.1-.1-.16-.25-.16-.46v-1.37h-.35v-.3h.35v-.59h.38v.59h.5v.3h-.5v1.27c0 .14.02.23.07.3.05.05.14.08.25.08h.08l.1-.01v.3c-.04.02-.08.02-.11.02l-.11.01Zm.78-.02v-3.15h.36v1.24h.03a.64.64 0 0 1 .25-.28c.1-.07.24-.1.41-.1.17 0 .31.03.43.1.12.06.2.16.27.28.06.12.09.28.09.45v1.46h-.36v-1.37c0-.2-.05-.35-.14-.45-.08-.1-.21-.15-.4-.15a.6.6 0 0 0-.3.08.53.53 0 0 0-.2.22c-.06.1-.08.2-.08.34v1.33h-.36Zm3.72 0v-3.15h.37v3.15h-.37Zm1.08 0v-2.25h.36v2.25h-.37Zm.18-2.69a.24.24 0 0 1-.18-.07.25.25 0 0 1-.07-.18.24.24 0 0 1 .25-.25.25.25 0 0 1 .25.25.25.25 0 0 1-.25.25Zm1.5 2.7-.83-2.26h.38l.62 1.86h.03l.62-1.86h.39l-.84 2.25h-.37Zm2.52.03c-.21 0-.4-.05-.55-.14a.94.94 0 0 1-.36-.4 1.42 1.42 0 0 1-.12-.62c0-.23.04-.44.12-.61a.96.96 0 0 1 .89-.56c.2 0 .38.05.53.14.15.1.26.23.34.4.08.17.12.36.12.59v.14h-1.81v-.3h1.62l-.18.27v-.14c0-.18-.03-.32-.08-.44a.56.56 0 0 0-.54-.34.6.6 0 0 0-.33.1.6.6 0 0 0-.22.25.98.98 0 0 0-.09.43v.14c0 .17.03.3.08.42.06.11.14.2.24.26.1.06.21.09.35.09.1 0 .2-.02.27-.04a.6.6 0 0 0 .18-.11.37.37 0 0 0 .1-.13l.02-.02h.36v.02a.68.68 0 0 1-.11.22.85.85 0 0 1-.47.33c-.1.04-.22.05-.36.05Zm2.76-.04v-3.15h.36v3.15h-.36Zm1.36.02a.27.27 0 0 1-.27-.27c0-.07.02-.14.07-.19a.27.27 0 0 1 .2-.08c.07 0 .14.03.19.08.05.05.08.12.08.2a.27.27 0 0 1-.27.26Zm1.08 0a.27.27 0 0 1-.27-.27c0-.07.03-.14.08-.19a.27.27 0 0 1 .2-.08c.07 0 .13.03.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.19a.26.26 0 0 1-.2.07Zm1.1 0a.27.27 0 0 1-.28-.27c0-.07.03-.14.08-.19a.27.27 0 0 1 .2-.08c.07 0 .13.03.18.08.06.05.08.12.08.2 0 .07-.02.13-.08.19a.26.26 0 0 1-.19.07Z"
              />
            </g>
            <rect
              width={73.6}
              height={6.12}
              x={89.51}
              y={101.74}
              stroke={templateStyles['border']}
              strokeWidth={0.31}
              rx={0.92}
            />
          </g>
        </g>
        <g filter="url(#contentLibrary-p)">
          <g clipPath="url(#contentLibrary-q)">
            <rect
              width={80.94}
              height={110.31}
              x={169.22}
              y={1.22}
              fill={templateStyles['background']}
              rx={1.84}
            />
            <path fill="url(#contentLibrary-r)" d="M171.67 3.67h76.04v50.8h-76.04z" />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.9}
              fontWeight={600}
              letterSpacing={0}
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={172.9} y={63.11}>
                {formatMessage(contentLibraryMessages['content-library.entry-3-cell-1'])}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={172.9} y={72.69}>
                {formatMessage(contentLibraryMessages['content-library.entry-3-cell-2'])}
              </tspan>
            </text>
            <rect
              width={29.7}
              height={5.92}
              x={173}
              y={77.6}
              fill={tagBackgroundColors['greyLight']}
              rx={0.78}
            />
            <rect
              width={29.7}
              height={5.92}
              x={173}
              y={77.6}
              stroke={tagBorderColors['greyLight']}
              strokeWidth={0.3}
              rx={0.78}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={174.28} y={81.87}>
                {formatMessage(
                  contentLibraryMessages['content-library.field-3-select-option-2']
                )}
              </tspan>
            </text>
            <rect
              width={17.7}
              height={5.92}
              x={173}
              y={86.1}
              fill={tagBackgroundColors['yellowLight']}
              rx={0.78}
            />
            <rect
              width={17.7}
              height={5.92}
              x={173}
              y={86.1}
              stroke={tagBorderColors['yellowLight']}
              strokeWidth={0.3}
              rx={0.78}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={174.13} y={90.44}>
                {formatMessage(
                  contentLibraryMessages['content-library.field-4-select-option-2']
                )}
              </tspan>
            </text>
            <g clipPath="url(#contentLibrary-u)">
              <rect
                width={73.6}
                height={6.12}
                x={172.9}
                y={94.86}
                fill={templateStyles['background']}
                rx={0.92}
              />
              <path
                fill={templateStyles['background']}
                d="M173.81 95.78h4.28v4.28h-4.28z"
              />
              <path
                fill={templateStyles['link']}
                d="M175.37 97.83c-.04-.05-.11-.04-.14.02l-.7 1.38v.04l.01.04a.08.08 0 0 0 .07.04h.97l.04-.01.03-.03c.21-.43.08-1.09-.28-1.48Zm.5-1.26c-.38.61-.36 1.3-.1 1.8l.47.94c.01.02.04.04.07.04h.97a.08.08 0 0 0 .07-.04v-.04a.1.1 0 0 0 0-.04l-1.33-2.66c-.03-.06-.1-.06-.14 0ZM179.4 99.86v-3.02h1.87v.34h-1.5v.97h1.42v.34h-1.41v1.03h1.5v.34h-1.88Zm2.33 0 .77-1.12-.78-1.13h.43l.53.84h.04l.53-.84h.4l-.76 1.11.78 1.14h-.43l-.54-.85h-.03l-.53.85h-.41Zm3.23.02c-.24 0-.4-.05-.5-.14-.11-.1-.16-.25-.16-.46V97.9h-.36v-.3h.36v-.59h.37v.59h.5v.3h-.5v1.28c0 .13.03.22.08.28.05.06.13.09.25.09a1.34 1.34 0 0 0 .17-.01v.3a2.7 2.7 0 0 1-.21.03Zm1.64.02a.94.94 0 0 1-.91-.54 1.42 1.42 0 0 1-.12-.62c0-.23.04-.44.12-.61.09-.18.2-.31.35-.41.16-.1.34-.15.54-.15s.38.05.53.14c.14.1.26.23.33.4.08.17.12.36.12.59v.14h-1.8v-.29h1.62l-.18.27v-.15c0-.18-.03-.32-.08-.44a.56.56 0 0 0-.54-.34.6.6 0 0 0-.33.1.6.6 0 0 0-.23.25.98.98 0 0 0-.08.43v.15c0 .16.03.3.08.4.06.12.13.2.23.27.1.06.22.09.36.09.1 0 .19-.02.27-.04a.59.59 0 0 0 .18-.11.38.38 0 0 0 .1-.13l.01-.02h.37v.02a.68.68 0 0 1-.11.22.84.84 0 0 1-.47.33c-.1.04-.23.05-.36.05Zm1.53-.04v-2.25h.36v.34h.04a.64.64 0 0 1 .24-.28c.11-.07.25-.1.41-.1.26 0 .45.07.59.22.13.14.2.35.2.61v1.46h-.36V98.5c0-.2-.05-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.53.53 0 0 0-.2.22c-.05.1-.08.2-.08.34v1.33h-.36Zm3.33.04a.87.87 0 0 1-.83-.55 1.5 1.5 0 0 1-.11-.61c0-.24.04-.45.11-.62a.94.94 0 0 1 .33-.4c.14-.1.31-.15.5-.15a.84.84 0 0 1 .54.18c.07.06.13.13.17.21h.03v-1.25h.36v3.15h-.36v-.36h-.03a.77.77 0 0 1-.7.4Zm.09-.32a.6.6 0 0 0 .35-.1c.1-.07.17-.17.23-.3.05-.12.08-.27.08-.44 0-.18-.03-.33-.08-.46a.65.65 0 0 0-.23-.29.6.6 0 0 0-.35-.1.6.6 0 0 0-.36.1.65.65 0 0 0-.22.3 1.2 1.2 0 0 0-.08.44c0 .18.03.33.08.46s.13.22.22.3c.1.06.22.1.36.1Zm3.72.3c-.23 0-.4-.05-.5-.14-.1-.1-.16-.25-.16-.46V97.9h-.36v-.3h.36v-.59h.38v.59h.49v.3h-.5v1.28c0 .13.03.22.08.28.05.06.13.09.25.09a1.37 1.37 0 0 0 .17-.01v.3a2.7 2.7 0 0 1-.21.03Zm.77-.02v-3.15h.37v1.24h.03a.64.64 0 0 1 .25-.28c.1-.07.24-.1.4-.1.18 0 .32.03.44.1.12.06.2.16.26.28a1 1 0 0 1 .1.45v1.46h-.37V98.5c0-.2-.04-.35-.13-.45-.08-.1-.21-.15-.4-.15a.6.6 0 0 0-.3.08.54.54 0 0 0-.21.22c-.05.1-.07.2-.07.34v1.33h-.37Zm3.43.04c-.22 0-.4-.04-.56-.14a.94.94 0 0 1-.35-.4 1.42 1.42 0 0 1-.13-.62c0-.23.04-.44.13-.61.08-.18.2-.31.35-.41.15-.1.33-.15.53-.15s.38.05.53.14c.15.1.26.23.34.4.08.17.12.36.12.59v.14h-1.8v-.29h1.61l-.18.27v-.15c0-.18-.02-.32-.08-.44a.56.56 0 0 0-.54-.34.6.6 0 0 0-.32.1.6.6 0 0 0-.23.25.98.98 0 0 0-.08.43v.15c0 .16.02.3.08.4.05.12.13.2.23.27.1.06.22.09.35.09.1 0 .2-.02.27-.04a.59.59 0 0 0 .19-.11.38.38 0 0 0 .1-.13v-.02h.37v.02a.68.68 0 0 1-.1.22.84.84 0 0 1-.48.33c-.1.04-.22.05-.35.05Zm2.73-.04v-2.25h.36v.33h.04a.53.53 0 0 1 .22-.27.82.82 0 0 1 .48-.1l.08.01v.36a1.07 1.07 0 0 0-.22-.02.66.66 0 0 0-.31.06.53.53 0 0 0-.21.2.54.54 0 0 0-.08.29v1.4h-.36Zm2.49.04c-.22 0-.4-.04-.56-.14a.94.94 0 0 1-.35-.4 1.43 1.43 0 0 1-.13-.62c0-.23.05-.44.13-.61.08-.18.2-.31.35-.41.15-.1.33-.15.53-.15.21 0 .39.05.53.14.15.1.26.23.34.4.08.17.12.36.12.59v.14h-1.8v-.29h1.61l-.18.27v-.15c0-.18-.02-.32-.07-.44a.56.56 0 0 0-.55-.34.6.6 0 0 0-.32.1.6.6 0 0 0-.23.25.97.97 0 0 0-.08.43v.15c0 .16.02.3.08.4a.6.6 0 0 0 .59.36c.1 0 .19-.02.26-.04a.59.59 0 0 0 .19-.11.4.4 0 0 0 .1-.13v-.02h.37v.02a.7.7 0 0 1-.1.22.84.84 0 0 1-.47.33c-.11.04-.23.05-.36.05Zm2.14 0a.89.89 0 0 1-.38-.08.66.66 0 0 1-.27-.23.64.64 0 0 1-.1-.36.6.6 0 0 1 .1-.34c.06-.1.16-.18.28-.23.12-.05.27-.09.44-.1l.83-.05v.3l-.78.05a.68.68 0 0 0-.38.1.31.31 0 0 0-.12.26c0 .12.05.2.13.27.09.07.2.1.33.1.12 0 .23-.03.33-.08s.17-.11.23-.2a.51.51 0 0 0 .08-.29v-.7c0-.14-.04-.25-.13-.32-.08-.07-.2-.1-.38-.1a.67.67 0 0 0-.33.06.35.35 0 0 0-.17.2v.01h-.37a.6.6 0 0 1 .15-.32.78.78 0 0 1 .3-.2c.13-.06.28-.08.44-.08.18 0 .34.03.46.09.13.06.23.15.3.26.06.1.1.24.1.4v1.54h-.37v-.33h-.03a.76.76 0 0 1-.4.33.9.9 0 0 1-.29.04Zm2.67 0c-.2 0-.4-.05-.55-.14a.96.96 0 0 1-.36-.4 1.41 1.41 0 0 1-.12-.63c0-.24.04-.44.12-.62a.95.95 0 0 1 .9-.54c.2 0 .35.03.48.1a.84.84 0 0 1 .47.62h-.36a.52.52 0 0 0-.19-.28.61.61 0 0 0-.4-.12.6.6 0 0 0-.57.4c-.05.12-.08.27-.08.44 0 .17.03.32.08.45s.13.23.23.3c.1.07.22.1.35.1.15 0 .28-.03.37-.1.1-.06.17-.16.2-.28l.01-.02h.36v.02a.95.95 0 0 1-.16.37.8.8 0 0 1-.31.24 1.1 1.1 0 0 1-.47.1Zm1.5-.04v-3.15h.36v1.24h.03a.65.65 0 0 1 .25-.28c.1-.07.25-.1.41-.1.17 0 .31.03.43.1.12.06.2.16.27.28.06.12.09.27.09.45v1.46h-.36V98.5c0-.2-.05-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.53.53 0 0 0-.2.22c-.06.1-.08.2-.08.34v1.33H211Zm4.63.04a.95.95 0 0 1-.91-.54 1.43 1.43 0 0 1-.13-.62c0-.25.04-.46.13-.63.08-.17.2-.3.36-.4.15-.1.34-.14.55-.14.22 0 .4.05.56.14.15.1.27.23.35.4.09.17.13.38.13.62 0 .25-.04.45-.13.63a.94.94 0 0 1-.9.54Zm0-.32c.14 0 .26-.03.36-.1.1-.07.18-.16.23-.29.05-.12.08-.27.08-.45s-.03-.34-.08-.46a.6.6 0 0 0-.23-.29.63.63 0 0 0-.36-.1.63.63 0 0 0-.36.1.62.62 0 0 0-.23.29 1.2 1.2 0 0 0-.08.45c0 .19.03.34.08.46.05.13.13.22.23.3.1.06.22.1.36.1Zm1.76.28v-1.95H217v-.3h.38v-.25c0-.15.02-.28.07-.38.05-.1.12-.17.22-.21a.8.8 0 0 1 .36-.08 1.18 1.18 0 0 1 .24.02v.3l-.07-.01h-.1c-.13 0-.22.02-.28.09-.05.06-.08.15-.08.28v.24h.51v.3h-.51v1.95h-.36Zm2.8.8-.09-.01a.7.7 0 0 1-.08 0v-.3H220.17c.1 0 .2-.02.26-.08a.54.54 0 0 0 .16-.27l.04-.13-.84-2.26h.4l.69 2.08-.14-.23h.17l-.15.23.7-2.08h.38l-.88 2.4c-.06.16-.13.3-.2.39a.56.56 0 0 1-.24.2.85.85 0 0 1-.34.05Zm2.97-.76a.95.95 0 0 1-.91-.54 1.42 1.42 0 0 1-.13-.62c0-.25.04-.46.13-.63.08-.17.2-.3.36-.4.15-.1.34-.14.55-.14.22 0 .4.05.56.14.15.1.27.23.35.4.09.17.13.38.13.62 0 .25-.04.45-.13.63a.93.93 0 0 1-.9.54Zm0-.32c.14 0 .26-.03.36-.1.1-.07.18-.16.23-.29.05-.12.08-.27.08-.45s-.03-.34-.08-.46a.61.61 0 0 0-.23-.29.63.63 0 0 0-.36-.1.63.63 0 0 0-.36.1.62.62 0 0 0-.23.29c-.05.12-.08.28-.08.45 0 .19.03.34.08.46.05.13.13.22.23.3.1.06.22.1.36.1Zm2.36.32a.88.88 0 0 1-.43-.1.62.62 0 0 1-.26-.28 1.08 1.08 0 0 1-.09-.45V97.6h.37v1.37c0 .2.04.35.12.45.08.1.2.15.39.15.1 0 .18-.01.26-.04a.51.51 0 0 0 .19-.13.52.52 0 0 0 .11-.2.86.86 0 0 0 .04-.27v-1.33h.37v2.25h-.37v-.33h-.03a.62.62 0 0 1-.15.2.64.64 0 0 1-.22.13.92.92 0 0 1-.3.04Zm1.75-.04v-2.25h.36v.33h.03a.53.53 0 0 1 .22-.27.82.82 0 0 1 .49-.1l.08.01v.36a1.02 1.02 0 0 0-.22-.02.66.66 0 0 0-.31.06.53.53 0 0 0-.21.2.54.54 0 0 0-.08.29v1.4h-.36Zm3.63.02c-.23 0-.4-.05-.5-.14-.1-.1-.15-.25-.15-.46V97.9h-.36v-.3h.36v-.59h.37v.59h.5v.3h-.5v1.28c0 .13.03.22.08.28.05.06.13.09.25.09a1.34 1.34 0 0 0 .17-.01v.3a2.7 2.7 0 0 1-.22.03Zm1.65.02a.94.94 0 0 1-.91-.54 1.42 1.42 0 0 1-.12-.62c0-.23.04-.44.12-.61a.96.96 0 0 1 .89-.56c.2 0 .38.05.53.14.14.1.26.23.34.4.07.17.11.36.11.59v.14h-1.8v-.29h1.62l-.18.27v-.15c0-.18-.03-.32-.08-.44a.56.56 0 0 0-.54-.34.6.6 0 0 0-.33.1.6.6 0 0 0-.23.25.99.99 0 0 0-.08.43v.15c0 .16.03.3.08.4.06.12.13.2.23.27.1.06.22.09.36.09.1 0 .19-.02.27-.04a.59.59 0 0 0 .18-.11.38.38 0 0 0 .1-.13l.01-.02h.37v.02a.7.7 0 0 1-.11.22.84.84 0 0 1-.47.33c-.1.04-.23.05-.36.05Zm2.15 0a.88.88 0 0 1-.39-.08.66.66 0 0 1-.27-.23.64.64 0 0 1-.1-.36.6.6 0 0 1 .1-.34c.06-.1.16-.18.28-.23.12-.05.27-.09.45-.1l.82-.05v.3l-.78.05a.69.69 0 0 0-.38.1.31.31 0 0 0-.11.26c0 .12.04.2.13.27.08.07.2.1.32.1.13 0 .24-.03.33-.08.1-.05.18-.11.23-.2a.52.52 0 0 0 .08-.29v-.7c0-.14-.04-.25-.12-.32-.09-.07-.21-.1-.38-.1a.67.67 0 0 0-.34.06.35.35 0 0 0-.17.2v.01h-.37a.6.6 0 0 1 .15-.32.79.79 0 0 1 .31-.2c.13-.06.27-.08.43-.08.18 0 .34.03.47.09.12.06.22.15.29.26.06.1.1.24.1.4v1.54h-.37v-.33h-.03a.76.76 0 0 1-.4.33.9.9 0 0 1-.28.04Zm1.74-.04v-2.25h.37v.34h.03a.6.6 0 0 1 .23-.28c.1-.07.23-.1.38-.1.1 0 .2.02.27.05a.67.67 0 0 1 .35.35h.04c.04-.09.09-.15.16-.21s.15-.1.23-.14c.1-.03.2-.05.3-.05.15 0 .28.03.38.08.11.06.2.15.25.26.06.1.08.24.08.4v1.55h-.36V98.4c0-.11-.02-.2-.05-.28a.33.33 0 0 0-.16-.16.55.55 0 0 0-.26-.06.5.5 0 0 0-.46.26.52.52 0 0 0-.06.26v1.45h-.37v-1.53a.45.45 0 0 0-.05-.23.38.38 0 0 0-.17-.15.53.53 0 0 0-.25-.06c-.1 0-.18.03-.26.08a.56.56 0 0 0-.19.2.63.63 0 0 0-.06.3v1.4h-.37Zm3.73-1.82.18-1.2h.42l-.33 1.2h-.27Zm1.3 1.84a.26.26 0 0 1-.2-.08.27.27 0 0 1-.08-.19c0-.07.03-.14.09-.19a.26.26 0 0 1 .19-.08c.07 0 .14.03.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.18a.26.26 0 0 1-.2.08Zm1.09 0a.26.26 0 0 1-.2-.08.27.27 0 0 1-.08-.19c0-.07.03-.14.08-.19a.26.26 0 0 1 .2-.08c.07 0 .13.03.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.18a.26.26 0 0 1-.2.08Zm1.08 0a.27.27 0 0 1-.27-.27c0-.07.03-.14.08-.19a.27.27 0 0 1 .2-.08c.07 0 .13.03.19.08.05.05.07.12.07.2 0 .07-.02.13-.07.18a.26.26 0 0 1-.2.08Z"
              />
            </g>
            <rect
              width={73.6}
              height={6.12}
              x={172.9}
              y={94.86}
              stroke={templateStyles['border']}
              strokeWidth={0.31}
              rx={0.92}
            />
          </g>
        </g>
        <g filter="url(#contentLibrary-v)">
          <g clipPath="url(#contentLibrary-w)">
            <rect
              width={80.94}
              height={110.31}
              x={252.61}
              y={1.22}
              fill={templateStyles['background']}
              rx={1.84}
            />
            <path fill="url(#contentLibrary-x)" d="M255.06 3.67h76.04v50.8h-76.04z" />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.9}
              fontWeight={600}
              letterSpacing={0}
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={256.28} y={63.11}>
                {formatMessage(contentLibraryMessages['content-library.entry-4-cell-1'])}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={256.28} y={72.69}>
                {formatMessage(contentLibraryMessages['content-library.entry-4-cell-2'])}
              </tspan>
            </text>
            <rect
              width={40.7}
              height={5.92}
              x={256}
              y={77.6}
              fill={tagBackgroundColors['tealLight']}
              rx={0.78}
            />
            <rect
              width={40.7}
              height={5.92}
              x={256}
              y={77.6}
              stroke={tagBorderColors['tealLight']}
              strokeWidth={0.3}
              rx={0.78}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={257.52} y={81.87}>
                {formatMessage(
                  contentLibraryMessages['content-library.field-3-select-option-4']
                )}
              </tspan>
            </text>
            <mask id="contentLibrary-z" fill={templateStyles['background']}>
              <path d="M256.28 87.21c0-.5.42-.91.92-.91h24.61c.51 0 .92.4.92.91v4.29c0 .5-.4.92-.92.92h-24.6a.92.92 0 0 1-.93-.92v-4.3Z" />
            </mask>
            <path
              fill={tagBackgroundColors['limeLight']}
              d="M256.28 87.21c0-.5.42-.91.92-.91h24.61c.51 0 .92.4.92.91v4.29c0 .5-.4.92-.92.92h-24.6a.92.92 0 0 1-.93-.92v-4.3Z"
            />
            <path
              fill={tagBackgroundColors['limeLight']}
              d="M257.2 86.6h24.61V86h-24.6v.61Zm25.23.61v4.29h.6v-4.3h-.6Zm-.62 4.9h-24.6v.61h24.6v-.61Zm-25.22-.61v-4.3h-.61v4.29h.61Zm.61.6a.61.61 0 0 1-.61-.6h-.61c0 .67.55 1.22 1.22 1.22v-.61Zm25.23-.6c0 .34-.28.6-.62.6v.62c.68 0 1.23-.55 1.23-1.22h-.61Zm-.62-4.9c.34 0 .62.28.62.61h.6c0-.67-.54-1.22-1.22-1.22v.61Zm-24.6-.61c-.68 0-1.23.55-1.23 1.22h.61c0-.33.27-.6.61-.6v-.62Z"
              mask="url(#contentLibrary-z)"
            />
            <rect
              width={28.7}
              height={5.92}
              x={256}
              y={86.1}
              fill={tagBackgroundColors['limeLight']}
              rx={0.78}
            />
            <rect
              width={28.7}
              height={5.92}
              x={256}
              y={86.1}
              stroke={tagBorderColors['limeLight']}
              strokeWidth={0.3}
              rx={0.78}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{ whiteSpace: 'pre' }}
            >
              <tspan x={257.55} y={90.44}>
                {formatMessage(
                  contentLibraryMessages['content-library.field-4-select-option-4']
                )}
              </tspan>
            </text>
            <g clipPath="url(#contentLibrary-A)">
              <rect
                width={73.6}
                height={6.12}
                x={256.28}
                y={94.86}
                fill={templateStyles['background']}
                rx={0.92}
              />
              <g clipPath="url(#contentLibrary-B)">
                <path
                  fill={templateStyles['background']}
                  d="M257.2 95.78h4.28v4.28h-4.28z"
                />
                <path
                  fill={templateStyles['link']}
                  d="M258.76 97.83c-.05-.05-.11-.04-.14.02l-.7 1.38v.08a.08.08 0 0 0 .08.04h.97l.04-.01.03-.03c.2-.43.08-1.09-.28-1.48Zm.5-1.26c-.38.61-.36 1.3-.1 1.8l.46.94c.02.02.05.04.08.04h.96a.08.08 0 0 0 .07-.04l.02-.04a.1.1 0 0 0-.01-.04l-1.33-2.66c-.03-.06-.1-.06-.15 0Z"
                />
              </g>
              <path
                fill={templateStyles['link']}
                d="m262.55 99.86 1.11-3.02h.29v.5h-.12l-.89 2.52h-.4Zm.5-.86.12-.32h1.36l.12.32h-1.6Zm1.7.86-.88-2.53v-.49h.16l1.12 3.02h-.4Zm.88 0v-2.25h.36v.34h.04a.64.64 0 0 1 .25-.28c.1-.07.24-.1.4-.1.26 0 .45.07.59.22.13.14.2.35.2.61v1.46h-.36V98.5c0-.2-.04-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.54.54 0 0 0-.2.22c-.05.1-.08.2-.08.34v1.33h-.36Zm2.5 0v-2.25h.37v.34h.03a.64.64 0 0 1 .25-.28c.1-.07.24-.1.4-.1.26 0 .45.07.59.22.14.14.2.35.2.61v1.46h-.36V98.5c0-.2-.04-.35-.13-.45-.08-.1-.22-.15-.4-.15a.6.6 0 0 0-.3.08.53.53 0 0 0-.21.22c-.05.1-.07.2-.07.34v1.33h-.37Zm3.43.04c-.21 0-.4-.04-.55-.14a.95.95 0 0 1-.36-.4 1.42 1.42 0 0 1-.13-.62c0-.25.04-.46.13-.63a.94.94 0 0 1 .91-.54c.21 0 .4.05.56.14.15.1.27.23.35.4.09.17.13.38.13.62 0 .25-.04.45-.13.63a.94.94 0 0 1-.9.54Zm0-.32c.14 0 .26-.03.36-.1.1-.07.18-.16.23-.29.05-.12.08-.27.08-.45s-.03-.34-.08-.46a.61.61 0 0 0-.23-.29.63.63 0 0 0-.36-.1.63.63 0 0 0-.36.1.62.62 0 0 0-.23.29 1.2 1.2 0 0 0-.08.45c0 .19.03.34.08.46.05.13.13.22.23.3.1.06.22.1.36.1Zm2.36.32a.87.87 0 0 1-.43-.1.63.63 0 0 1-.26-.28 1.1 1.1 0 0 1-.09-.45V97.6h.37v1.37c0 .2.04.35.12.45.07.1.2.15.38.15.1 0 .2-.01.27-.04a.5.5 0 0 0 .3-.33.83.83 0 0 0 .04-.27v-1.33h.37v2.25h-.37v-.33h-.03a.63.63 0 0 1-.15.2.64.64 0 0 1-.23.13.91.91 0 0 1-.29.04Zm1.75-.04v-2.25h.36v.34h.04a.64.64 0 0 1 .24-.28c.1-.07.25-.1.41-.1.25 0 .45.07.58.22.14.14.21.35.21.61v1.46h-.36V98.5c0-.2-.05-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.53.53 0 0 0-.2.22c-.06.1-.08.2-.08.34v1.33h-.36Zm3.42.04c-.2 0-.4-.05-.55-.14a.96.96 0 0 1-.36-.4 1.41 1.41 0 0 1-.12-.63c0-.24.04-.44.12-.62a.96.96 0 0 1 .9-.54c.2 0 .35.03.48.1a.83.83 0 0 1 .47.62h-.36a.52.52 0 0 0-.19-.28.62.62 0 0 0-.4-.12.6.6 0 0 0-.57.4c-.06.12-.08.27-.08.44 0 .17.03.32.08.45s.13.23.23.3c.1.07.21.1.35.1.15 0 .28-.03.37-.1.1-.06.17-.16.2-.28l.01-.02h.36v.02a.95.95 0 0 1-.16.37.8.8 0 0 1-.31.24 1.1 1.1 0 0 1-.47.1Zm1.49-.04v-2.25h.36v2.25h-.37Zm.18-2.69a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18.25.25 0 0 1 .25-.25c.07 0 .13.03.18.07.05.05.07.11.07.18 0 .07-.02.13-.07.18a.24.24 0 0 1-.18.07Zm.87 2.7V97.6h.36v.34h.03a.64.64 0 0 1 .25-.28c.1-.07.24-.1.4-.1.26 0 .46.07.6.22.13.14.2.35.2.61v1.46h-.37V98.5c0-.2-.04-.35-.13-.45-.08-.1-.21-.15-.4-.15a.6.6 0 0 0-.3.08.53.53 0 0 0-.21.22c-.05.1-.07.2-.07.34v1.33h-.37Zm3.43.79c-.19 0-.34-.03-.48-.08a.77.77 0 0 1-.32-.22.63.63 0 0 1-.15-.32h.38c.02.09.08.16.18.21.1.06.22.09.38.09.2 0 .37-.05.48-.14.11-.1.17-.22.17-.39v-.45h-.03a.75.75 0 0 1-.42.34.92.92 0 0 1-.3.05.9.9 0 0 1-.5-.14.91.91 0 0 1-.32-.39 1.3 1.3 0 0 1-.12-.56c0-.21.04-.4.12-.56a.9.9 0 0 1 .84-.53c.1 0 .2.02.29.05.09.03.17.08.24.14.07.06.12.14.17.22h.03v-.37h.36v2.22c0 .17-.04.31-.12.44a.78.78 0 0 1-.35.29c-.15.06-.33.1-.53.1Zm-.02-1.24a.63.63 0 0 0 .59-.37.9.9 0 0 0 .08-.39.92.92 0 0 0-.08-.4.62.62 0 0 0-.23-.27.63.63 0 0 0-.36-.1.62.62 0 0 0-.36.1.64.64 0 0 0-.22.27 1 1 0 0 0-.07.4c0 .15.02.28.07.4.05.11.13.2.22.27.1.06.22.1.36.1Zm4.16.51c-.27 0-.5-.06-.7-.19-.2-.13-.36-.3-.47-.54-.1-.24-.16-.52-.16-.84 0-.33.06-.61.16-.85.11-.23.26-.42.46-.54.2-.13.44-.2.71-.2.21 0 .4.05.58.13a1.08 1.08 0 0 1 .64.85h-.38a.83.83 0 0 0-.84-.63.85.85 0 0 0-.83.58c-.07.18-.11.4-.11.65 0 .26.04.48.11.66.08.18.19.33.33.43.14.1.31.15.5.15.14 0 .27-.03.39-.07a.79.79 0 0 0 .29-.2.7.7 0 0 0 .16-.3h.38a1.04 1.04 0 0 1-.64.8c-.17.08-.36.11-.58.11Zm2.74-.03a.95.95 0 0 1-.91-.54 1.43 1.43 0 0 1-.13-.62c0-.25.04-.46.12-.63.09-.17.2-.3.36-.4.16-.1.34-.14.56-.14.21 0 .4.05.55.14.15.1.27.23.36.4.08.17.13.38.13.62 0 .25-.05.45-.13.63a.94.94 0 0 1-.91.54Zm0-.32c.14 0 .26-.03.36-.1.1-.07.17-.16.22-.29.06-.12.08-.27.08-.45s-.02-.34-.08-.46a.6.6 0 0 0-.22-.29.63.63 0 0 0-.36-.1.63.63 0 0 0-.37.1.62.62 0 0 0-.22.29 1.2 1.2 0 0 0-.08.45c0 .19.02.34.08.46.05.13.13.22.22.3.1.06.22.1.37.1Zm1.6.28v-2.25h.36v.34h.04a.65.65 0 0 1 .24-.28c.11-.07.25-.1.41-.1.26 0 .45.07.59.22.13.14.2.35.2.61v1.46h-.36V98.5c0-.2-.04-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.53.53 0 0 0-.2.22c-.05.1-.08.2-.08.34v1.33h-.36Zm2.65 0v-1.95h-.37v-.3h.37v-.25c0-.15.03-.28.08-.38.05-.1.12-.17.22-.21a.8.8 0 0 1 .36-.08 1.18 1.18 0 0 1 .24.02v.3l-.08-.01h-.09c-.13 0-.22.02-.28.09-.06.06-.08.15-.08.28v.24h.5v.3h-.5v1.95h-.37Zm1.43 0v-3.15h.36v3.15h-.37Zm1.81.04a.88.88 0 0 1-.43-.1.62.62 0 0 1-.26-.28 1.08 1.08 0 0 1-.08-.45V97.6h.36v1.37c0 .2.04.35.12.45.08.1.2.15.39.15.1 0 .18-.01.26-.04a.51.51 0 0 0 .2-.13.54.54 0 0 0 .1-.2.86.86 0 0 0 .05-.27v-1.33h.36v2.25h-.36v-.33h-.04a.63.63 0 0 1-.15.2.64.64 0 0 1-.22.13.92.92 0 0 1-.3.04Zm2.67 0a.94.94 0 0 1-.91-.54 1.43 1.43 0 0 1-.12-.62c0-.23.04-.44.12-.61.08-.18.2-.31.35-.41.16-.1.33-.15.54-.15.2 0 .38.05.52.14.15.1.26.23.34.4.08.17.12.36.12.59v.14h-1.8v-.29h1.62l-.18.27v-.15c0-.18-.03-.32-.08-.44a.56.56 0 0 0-.55-.34.6.6 0 0 0-.32.1.6.6 0 0 0-.23.25.97.97 0 0 0-.08.43v.15c0 .16.03.3.08.4.06.12.13.2.23.27.1.06.22.09.36.09.1 0 .19-.02.26-.04a.59.59 0 0 0 .19-.11.4.4 0 0 0 .1-.13l.01-.02h.37v.02a.7.7 0 0 1-.11.22.84.84 0 0 1-.47.33c-.1.04-.23.05-.36.05Zm1.53-.04v-2.25h.36v.34h.03a.65.65 0 0 1 .25-.28c.1-.07.25-.1.41-.1.25 0 .45.07.58.22.14.14.21.35.21.61v1.46h-.36V98.5c0-.2-.05-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.53.53 0 0 0-.2.22c-.06.1-.08.2-.08.34v1.33h-.36Zm3.42.04c-.2 0-.4-.05-.55-.14a.96.96 0 0 1-.36-.4 1.4 1.4 0 0 1-.12-.63c0-.24.04-.44.12-.62a.96.96 0 0 1 .9-.54c.2 0 .35.03.48.1a.83.83 0 0 1 .47.62h-.36a.52.52 0 0 0-.19-.28.62.62 0 0 0-.4-.12.6.6 0 0 0-.57.4c-.06.12-.08.27-.08.44 0 .17.03.32.08.45s.13.23.23.3c.1.07.22.1.35.1.15 0 .27-.03.37-.1.1-.06.17-.16.2-.28l.01-.02h.36v.02a.95.95 0 0 1-.17.37.8.8 0 0 1-.3.24 1.1 1.1 0 0 1-.47.1Zm2.4 0c-.22 0-.4-.04-.56-.14a.94.94 0 0 1-.35-.4 1.42 1.42 0 0 1-.13-.62c0-.23.04-.44.13-.61.08-.18.2-.31.35-.41.15-.1.33-.15.53-.15s.38.05.53.14c.15.1.26.23.34.4.08.17.12.36.12.59v.14h-1.8v-.29h1.61l-.18.27v-.15c0-.18-.02-.32-.08-.44a.56.56 0 0 0-.54-.34.6.6 0 0 0-.32.1.6.6 0 0 0-.23.25.98.98 0 0 0-.08.43v.15c0 .16.02.3.08.4.05.12.13.2.23.27.1.06.22.09.35.09.1 0 .2-.02.27-.04a.59.59 0 0 0 .19-.11.38.38 0 0 0 .1-.13v-.02h.37v.02a.68.68 0 0 1-.1.22.84.84 0 0 1-.48.33c-.1.04-.22.05-.35.05Zm3.99.03c-.27 0-.51-.06-.7-.19-.2-.13-.36-.3-.47-.54a2 2 0 0 1-.16-.84 2 2 0 0 1 .16-.85c.1-.23.26-.42.46-.54.2-.13.44-.2.7-.2.22 0 .41.05.58.13a1.1 1.1 0 0 1 .65.85h-.38a.83.83 0 0 0-.84-.63c-.2 0-.36.05-.5.15a.96.96 0 0 0-.33.43c-.08.18-.12.4-.12.65 0 .26.04.48.12.66.08.18.19.33.33.43.14.1.3.15.5.15.14 0 .27-.03.38-.07a.8.8 0 0 0 .3-.2.7.7 0 0 0 .15-.3h.39a1.04 1.04 0 0 1-.64.8c-.17.08-.37.11-.58.11Zm1.83-.07v-3.15h.36v3.15h-.36Zm1.99.04a.95.95 0 0 1-.91-.54 1.43 1.43 0 0 1-.13-.62c0-.25.04-.46.12-.63.09-.17.2-.3.36-.4.16-.1.34-.14.56-.14.21 0 .4.05.55.14.15.1.27.23.36.4.08.17.13.38.13.62 0 .25-.05.45-.13.63a.94.94 0 0 1-.91.54Zm0-.32c.14 0 .26-.03.36-.1.1-.07.17-.16.22-.29.06-.12.08-.27.08-.45s-.02-.34-.08-.46a.6.6 0 0 0-.22-.29.63.63 0 0 0-.36-.1.63.63 0 0 0-.37.1.62.62 0 0 0-.22.29 1.2 1.2 0 0 0-.08.45c0 .19.02.34.08.46.05.13.13.22.22.3.1.06.22.1.37.1Zm2.36.32a.88.88 0 0 1-.43-.1.62.62 0 0 1-.26-.28 1.1 1.1 0 0 1-.1-.45V97.6h.37v1.37c0 .2.04.35.12.45.08.1.2.15.39.15.1 0 .19-.01.26-.04a.5.5 0 0 0 .3-.33.83.83 0 0 0 .05-.27v-1.33h.36v2.25h-.36v-.33h-.03a.63.63 0 0 1-.15.2.64.64 0 0 1-.23.13.92.92 0 0 1-.3.04Zm2.57 0a.87.87 0 0 1-.82-.55 1.5 1.5 0 0 1-.12-.61c0-.24.04-.45.12-.62a.87.87 0 0 1 .83-.55.83.83 0 0 1 .53.18c.07.06.13.13.17.21h.03v-1.25h.37v3.15h-.37v-.36h-.03a.78.78 0 0 1-.18.22.77.77 0 0 1-.24.14.85.85 0 0 1-.29.04Zm.09-.32a.6.6 0 0 0 .35-.1c.1-.07.18-.17.23-.3.05-.12.08-.27.08-.44 0-.18-.03-.33-.08-.46a.65.65 0 0 0-.23-.29.6.6 0 0 0-.35-.1.6.6 0 0 0-.35.1.64.64 0 0 0-.23.3c-.05.12-.08.27-.08.44 0 .18.03.33.08.46s.13.22.23.3c.1.06.21.1.35.1Zm2.01.3a.27.27 0 0 1-.2-.08.27.27 0 0 1-.07-.19c0-.07.03-.14.08-.19a.27.27 0 0 1 .2-.08c.07 0 .13.03.18.08.06.05.08.12.08.2 0 .07-.02.13-.08.18a.26.26 0 0 1-.19.08Zm1.09 0a.26.26 0 0 1-.2-.08.27.27 0 0 1-.07-.19c0-.07.02-.14.08-.19a.26.26 0 0 1 .19-.08c.07 0 .14.03.2.08.04.05.07.12.07.2 0 .07-.03.13-.08.18a.26.26 0 0 1-.2.08Zm1.09 0a.26.26 0 0 1-.2-.08.27.27 0 0 1-.08-.19c0-.07.03-.14.08-.19a.26.26 0 0 1 .2-.08c.07 0 .14.03.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.18a.26.26 0 0 1-.2.08Z"
              />
            </g>
            <rect
              width={73.6}
              height={6.12}
              x={256.28}
              y={94.86}
              stroke={templateStyles['border']}
              strokeWidth={0.31}
              rx={0.92}
            />
          </g>
        </g>
        <g filter="url(#contentLibrary-C)">
          <g clipPath="url(#contentLibrary-D)">
            <rect
              width={80.94}
              height={116.31}
              x={2.45}
              y={113.98}
              fill={templateStyles['background']}
              rx={1.84}
            />
            <path fill="url(#contentLibrary-E)" d="M4.9 116.43h76.04v50.8H4.9z" />
          </g>
        </g>
        <g filter="url(#contentLibrary-F)">
          <g clipPath="url(#contentLibrary-G)">
            <rect
              width={80.94}
              height={123.32}
              x={85.84}
              y={113.98}
              fill={templateStyles['background']}
              rx={1.84}
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="contentLibrary-a">
          <rect width={336} height={142} fill={templateStyles['background']} rx={3} />
        </clipPath>
        <clipPath id="contentLibrary-c">
          <rect
            width={80.94}
            height={110.31}
            x={2.45}
            y={1.22}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <clipPath id="contentLibrary-g">
          <rect
            width={73.6}
            height={6.12}
            x={6.12}
            y={101.74}
            fill={templateStyles['background']}
            rx={0.92}
          />
        </clipPath>
        <clipPath id="contentLibrary-h">
          <path fill={templateStyles['background']} d="M7.04 102.66h4.28v4.28H7.04z" />
        </clipPath>
        <clipPath id="contentLibrary-j">
          <rect
            width={80.94}
            height={110.31}
            x={85.84}
            y={1.22}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <clipPath id="contentLibrary-n">
          <rect
            width={73.6}
            height={6.12}
            x={89.51}
            y={101.74}
            fill={templateStyles['background']}
            rx={0.92}
          />
        </clipPath>
        <clipPath id="contentLibrary-o">
          <path fill={templateStyles['background']} d="M90.43 102.66h4.28v4.28h-4.28z" />
        </clipPath>
        <clipPath id="contentLibrary-q">
          <rect
            width={80.94}
            height={110.31}
            x={169.22}
            y={1.22}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <clipPath id="contentLibrary-u">
          <rect
            width={73.6}
            height={6.12}
            x={172.9}
            y={94.86}
            fill={templateStyles['background']}
            rx={0.92}
          />
        </clipPath>
        <clipPath id="contentLibrary-w">
          <rect
            width={80.94}
            height={110.31}
            x={252.61}
            y={1.22}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <clipPath id="contentLibrary-A">
          <rect
            width={73.6}
            height={6.12}
            x={256.28}
            y={94.86}
            fill={templateStyles['background']}
            rx={0.92}
          />
        </clipPath>
        <clipPath id="contentLibrary-B">
          <path fill={templateStyles['background']} d="M257.2 95.78h4.28v4.28h-4.28z" />
        </clipPath>
        <clipPath id="contentLibrary-D">
          <rect
            width={80.94}
            height={116.31}
            x={2.45}
            y={113.98}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <clipPath id="contentLibrary-G">
          <rect
            width={80.94}
            height={123.32}
            x={85.84}
            y={113.98}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <filter
          id="contentLibrary-b"
          width={81.55}
          height={111.23}
          x={2.14}
          y={0.92}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_9035" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_9035"
            result="effect2_dropShadow_1228_9035"
          />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_1228_9035" result="shape" />
        </filter>
        <filter
          id="contentLibrary-i"
          width={81.55}
          height={111.23}
          x={85.53}
          y={0.92}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_9035" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_9035"
            result="effect2_dropShadow_1228_9035"
          />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_1228_9035" result="shape" />
        </filter>
        <filter
          id="contentLibrary-p"
          width={81.55}
          height={111.23}
          x={168.92}
          y={0.92}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_9035" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_9035"
            result="effect2_dropShadow_1228_9035"
          />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_1228_9035" result="shape" />
        </filter>
        <filter
          id="contentLibrary-v"
          width={81.55}
          height={111.23}
          x={252.31}
          y={0.92}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_9035" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_9035"
            result="effect2_dropShadow_1228_9035"
          />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_1228_9035" result="shape" />
        </filter>
        <filter
          id="contentLibrary-C"
          width={81.55}
          height={117.23}
          x={2.14}
          y={113.68}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_9035" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_9035"
            result="effect2_dropShadow_1228_9035"
          />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_1228_9035" result="shape" />
        </filter>
        <filter
          id="contentLibrary-F"
          width={81.55}
          height={124.24}
          x={85.53}
          y={113.68}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_9035" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_9035"
            result="effect2_dropShadow_1228_9035"
          />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_1228_9035" result="shape" />
        </filter>
        <pattern
          id="contentLibrary-d"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#contentLibrary-H" transform="scale(.001 .0015)" />
        </pattern>
        <pattern
          id="contentLibrary-k"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#contentLibrary-I" transform="scale(.001 .0015)" />
        </pattern>
        <pattern
          id="contentLibrary-r"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#contentLibrary-J" transform="scale(.001 .0015)" />
        </pattern>
        <pattern
          id="contentLibrary-x"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#contentLibrary-K" transform="scale(.001 .0015)" />
        </pattern>
        <pattern
          id="contentLibrary-E"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#contentLibrary-L" transform="matrix(.0014 0 0 .002 .01 -.2)" />
        </pattern>
        <image
          xlinkHref={documentation}
          id="contentLibrary-H"
          width={984}
          height={664}
          preserveAspectRatio="none"
        />
        <image
          xlinkHref={customerVideos}
          id="contentLibrary-I"
          width={984}
          height={664}
          preserveAspectRatio="none"
        />
        <image
          xlinkHref={marketingContent}
          id="contentLibrary-J"
          width={984}
          height={664}
          preserveAspectRatio="none"
        />
        <image
          xlinkHref={technicalSupport}
          id="contentLibrary-K"
          width={984}
          height={664}
          preserveAspectRatio="none"
        />
        <image
          xlinkHref={publicForum}
          id="contentLibrary-L"
          width={738}
          height={498}
          preserveAspectRatio="none"
        />
      </defs>
    </svg>
  );
};
export default ContentLibrary;
